<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="QR-Code"
    iconPath="assets/icons/calendar-dots-light.svg"
  />

  <div class="p-6 flex flex-col gap-6 mb-20">
    <div class="flex justify-between p-3 rounded gap-6 text-lg">
      <div class="flex flex-col justify-center items-start">
        <span class="font-medium">Datum</span>
        <span>{{ data.activity.scheduledDate | dayjsFormat: 'date' }}</span>
      </div>

      <div class="flex flex-col justify-center items-start">
        <span class="font-medium">Typ</span>
        <span>{{ activityTypeLabel() }}</span>
      </div>
    </div>

    <div class="relative w-full aspect-square bg-gray-100">
      <canvas
        #qrCanvas
        class="absolute top-0 left-0 w-full h-full"
      ></canvas>
    </div>
  </div>
</div>
